  export default [
    {
      path: "/",
      name: "index",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/dashboard/index.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin", "accounts"],
      },
    },
    {
      path: "/documents",
      name: "documents",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/documents/Documents.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/document-categories",
      name: "document-categories",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/documents/DocumentCategories.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/photolibrary",
      name: "photolibrary",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/photolibrary/Photolibrary.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/photolibrary-applications",
      name: "photolibrary-applications",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/photolibrary/PhotolibraryApplications.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/user-manager",
      name: "users-list",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/users/UsersList.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/hero-manager",
      name: "hero-manager",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/heroImages/HeroImages.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/website-visitors",
      name: "website-visitors",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/userTracking/WebsiteVisitors.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/website-views",
      name: "website-views",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/userTracking/WebsiteViews.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/clearance-carousel",
      name: "clearance-carousel",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/ClearanceCarousel.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
    {
      path: "/support-management",
      name: "support-management",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import(
          /* webpackChunkName: "about" */ "../views/support/Support.vue"
        );
      },
      meta: {
        publicPage: false,
        adminType: ["admin", "s_admin"],
      },
    },
  ];
